<p-drawer
    [visible]="visible()"
    (visibleChange)="onVisibleChange($event)"
    position="right"
    [style]="{ width: '420px' }"
    [showCloseIcon]="false"
    appendTo="body"
    styleClass="guia-usuario-drawer"
>
    <ng-template #header>
        <div class="flex align-items-center justify-content-between w-full px-1">
            <div class="flex align-items-center gap-2">
                <i class="pi pi-question-circle text-primary"></i>
                <span class="font-semibold text-base">Guía de usuario</span>
            </div>
            <button
                pButton
                type="button"
                icon="pi pi-times"
                severity="secondary"
                [text]="true"
                (click)="cerrar()"
                aria-label="Cerrar guía de usuario"
            ></button>
        </div>
    </ng-template>

    <div class="guia-buscador">
        <p-iconfield iconPosition="left">
            <p-inputicon>
                <i class="pi pi-search"></i>
            </p-inputicon>
            <input
                pInputText
                type="text"
                class="w-full"
                [ngModel]="busqueda()"
                (ngModelChange)="onBusquedaChange($event)"
                placeholder="Buscar en la guía"
                aria-label="Buscar en la guía de usuario"
            />
        </p-iconfield>
    </div>

    @if (cargando()) {
        <div class="guia-estado">
            <p-progressSpinner styleClass="guia-spinner" strokeWidth="4" ariaLabel="Cargando la guía"></p-progressSpinner>
            <span>Cargando la guía…</span>
        </div>
    } @else if (error()) {
        <div class="guia-estado guia-estado--error">
            <i class="pi pi-exclamation-triangle"></i>
            <span>{{ error() }}</span>
            <button pButton type="button" label="Reintentar" icon="pi pi-refresh" [text]="true" size="small" (click)="reintentar()"></button>
        </div>
    } @else if (sinResultados()) {
        <div class="guia-estado">
            <i class="pi pi-inbox"></i>
            <span>
                @if (busqueda().trim()) {
                    No hay temas que coincidan con “{{ busqueda().trim() }}”.
                } @else {
                    Todavía no hay contenido publicado para este portal.
                }
            </span>
        </div>
    } @else {
        <p-accordion [value]="temaAbierto()" (valueChange)="onTemaAbiertoChange($event)" styleClass="guia-acordeon">
            @for (item of temas(); track item.tema) {
                <p-accordion-panel [value]="item.tema">
                    <p-accordion-header>
                        <span class="guia-tema__titulo">{{ item.tema }}</span>
                    </p-accordion-header>

                    <p-accordion-content>
                        <!-- Texto del tema: se pide al expandir, no en el listado. -->
                        @if (item.texto) {
                            @let estado = estadoContenido(item.texto);

                            @if (estado?.cargando) {
                                <div class="guia-estado guia-estado--compacto">
                                    <p-progressSpinner styleClass="guia-spinner" strokeWidth="4" ariaLabel="Cargando el texto"></p-progressSpinner>
                                </div>
                            } @else if (estado?.error) {
                                <div class="guia-estado guia-estado--compacto guia-estado--error">
                                    <span>{{ estado?.error }}</span>
                                    <button
                                        pButton
                                        type="button"
                                        label="Reintentar"
                                        icon="pi pi-refresh"
                                        [text]="true"
                                        size="small"
                                        (click)="reintentarContenido(item.texto)"
                                    ></button>
                                </div>
                            } @else if (estado?.html) {
                                <div class="guia-texto" [innerHTML]="estado?.html"></div>
                            } @else if (estado) {
                                <p class="guia-texto__vacio">Este tema no tiene texto escrito todavía.</p>
                            }
                        }

                        <!-- Archivos del tema: PDF y video, al final. -->
                        @if (item.archivos.length) {
                            <div class="guia-archivos">
                                @for (archivo of item.archivos; track archivo.id) {
                                    <button
                                        pButton
                                        type="button"
                                        [label]="archivo.titulo"
                                        [icon]="iconoDe(archivo)"
                                        severity="secondary"
                                        [outlined]="true"
                                        size="small"
                                        class="guia-archivos__boton"
                                        [pTooltip]="archivo.descripcion || archivo.nombreArchivo"
                                        tooltipPosition="left"
                                        (click)="abrir(archivo)"
                                    ></button>
                                }
                            </div>
                        }

                        @if (!item.texto && !item.archivos.length) {
                            <p class="guia-texto__vacio">Este tema todavía no tiene contenido.</p>
                        }
                    </p-accordion-content>
                </p-accordion-panel>
            }
        </p-accordion>
    }
</p-drawer>
